export const APP_NAME = 'Hiring Management System';
export const APP_PATH_PREFIX = '/app';
export const AUTH_PATH_PREFIX = '/auth';
export const PUBLIC_PATH_PREFIX = '/public';
export const URL_REDIRECT_KEY = 'redirect';
export const AUTHENTICATED_ENTRY = `${APP_PATH_PREFIX}/home`;
export const UNAUTHENTICATED_ENTRY = '/login';
export const AUTH_TOKEN = 'token';
export const REFRESH_TOKEN = 'refresh_token';
// export const API_URL = "http://localhost:4000";
function ApiURL() {
  let API_URL;
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'PROD':
      API_URL = 'https://hrms.lumaxiac.com';
      break;
    case 'DEV':
      // API_URL = 'http://82.25.104.110:49186';
      API_URL = 'https://iachr.dev.jetatech.cloud';
      break;
    case 'LOCAL':
      API_URL = 'http://localhost:4000';
      break;
    default:
      API_URL = 'http://localhost:4000';
      break;
  }
  return API_URL;
}

export const API_URL = ApiURL();
